import React, { lazy, Suspense, useEffect, useMemo, useState, useTransition } from "react"
import { Box, Stack, Typography, Divider, Skeleton } from "@mui/material"

// Type
import type { SyntheticEvent } from "react"

// Componenets
import ProductImages from "./ProductImages"

// Assets

// Data
import { useAppDispatch, useAppSelector } from "@/hooks"
import { getDefaultOption } from "@/utils/common"
import Toaster from "@/components/common/Toaster"
import { resetProductDetails } from "@/redux/reducers/categoryReducer"

import noImage from '../../../assets/images/noImage.png'
import RenderOnViewportEntry from "@/components/common/RenderOnViewportEntry"
import ProductDescription from "@/components/partials/productDetail/ProductDescription"
import PricingDetails from "@/components/partials/productDetail/PricingDetails"
// const PricingDetails = lazy(() => import("@/components/partials/productDetail/PricingDetails"));
// const ProductDescription = lazy(() => import("@/components/partials/productDetail/ProductDescription"));

function AboutProduct({ productId, productDetailsData, configDetailsState, isMobile }: any) {
  const dispatch = useAppDispatch();
  const [isRendering, setIsRendering] = useState(true);

  const { openToaster } = useAppSelector((state) => state.homePage)
  const defaultTabValue = useMemo(() => {
    const defaultTabValue = getDefaultOption([
      { enabled: productDetailsData?.isProductDescriptionShow, value: 0 },
      { enabled: productDetailsData?.isAdditionalInformationShow, value: 1 },
      { enabled: productDetailsData?.isRatingReviewShow, value: 2 },
    ], 0);
    return defaultTabValue
  }, [productDetailsData]);
  const [tabValue, setTabValue] = useState<number>(defaultTabValue)

  const handleTabChange = (event: SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }
  const [isPending, startTransition] = useTransition();
  useEffect(() => {
    startTransition(() => {
      // Simulating initial data fetch
      setTimeout(() => setIsRendering(false), isMobile ? 0 : 0);
    });
    return () => {
      dispatch(resetProductDetails())
    }
  }, [])

  return (
    <Box className="AboutProduct">
      {openToaster && <Toaster />}
      <Stack className="AboutWrapper">
        <ProductImages
          productImages={productDetailsData?.imageUrls?.length > 0 ? productDetailsData?.imageUrls : [noImage]}
          offerBadge={
            <Typography
              variant="titleLarge"
              className="OfferBadge"
              sx={{ backgroundColor: productDetailsData?.tagColor }}
            >
              {productDetailsData?.tagName}
            </Typography>
          }
        />
        <Box className="ProductAbout">
          <form>
            <Box className="Heading">
              <Typography className="ProductName" variant="h4" component="h1" >{productDetailsData?.name}</Typography>
              <Stack className="Wrapper">
                <Typography>{productDetailsData?.shortDescription}</Typography>
              </Stack>
            </Box>
            <Divider />
            <PricingDetails
              productId={productId} productDetailsData={productDetailsData} configDetailsState={configDetailsState}
            />
            {/* {!isRendering && <Suspense fallback={
              <Skeleton
                height={isMobile ? "141px" : "315px"}
                width={"100%"}
              // style={{ transform: "scale(1)" }} 
              />}>
              <PricingDetails
                productId={productId} productDetailsData={productDetailsData} configDetailsState={configDetailsState}
              />
            </Suspense>} */}
          </form>
        </Box>
      </Stack>
      {/* <RenderOnViewportEntry
        rootMargin="200px"
        threshold={0.25}
        minHeight={800}
      >
        <ProductDescription productDetailsData={productDetailsData} />
      </RenderOnViewportEntry> */}
      <ProductDescription productDetailsData={productDetailsData} />
    </Box>
  )
}

export default React.memo(AboutProduct)